import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@b2b/env/environment';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.serverUrl}${this.baseUrl}`;
  }

  showProducts(comp_slug: string) {
    return this.http.get(this.baseUrl + 'competitions/' + comp_slug + '/legacy_categories/');
  }

  getCart() {
    return this.http.get(this.baseUrl + 'transactions/cart/');
  }

  addToCart(cart_uuid: string, data) {
    return this.http.post(this.baseUrl + 'transactions/' + cart_uuid + '/items/', data);
  }

  updateItem(cart_uuid: string, item_pk: number, data) {
    return this.http.put(this.baseUrl + 'transactions/' + cart_uuid + '/items/' + item_pk + '/', data);
  }

  viewCart(cart_uuid: string) {
    return this.http.get(this.baseUrl + 'transactions/' + cart_uuid + '/');
  }

  getCompInfo(comp_slug: string) {
    return this.http.get(this.baseUrl + 'competitions/' + comp_slug + '/light/');
  }

  membershipPayment(payment_details) {
    return this.http.post(this.baseUrl + 'membership_neo_payment/', payment_details);
  }

  hasActiveMembership(comp_slug: string) {
    return this.http.get(this.baseUrl + 'competitions/' + comp_slug + '/has_active_memberships/');
  }

}
